module.exports = __webpack_public_path__ + "assets/img/list-logo-zh.f926371c.png";